import { pipe, splitEvery, flatten } from 'ramda';
import { ixMap } from './helpers.js';
import { generate } from 'shortid';


// generate schedule for POINTS table competition type
export const getPointsSchedule = (teams, competition, beginTimeInSeconds) => {
  const {
    concurrentCompetitors,
    attemptsLimit,
    attemptMaxLengthInSeconds: l
  } = competition;
  
  return pipe(
    splitEvery(concurrentCompetitors || 3),
    
    ixMap((matchTeams, groupIx, groups) => {
      //const matchId = generate();

      return ixMap((team, teamIx) => {
        const matches = [];
        for (let attemptIx = 0; attemptIx < attemptsLimit; attemptIx +=1) {
          // let bTime = beginTimeInSeconds;
          // bTime += groupIx * (groups.length * l);
          // bTime += attemptIx * l;
          
          let bTime = beginTimeInSeconds;
          // increment begin time according to groups and matches
          bTime += groupIx * l + (groups.length * attemptIx * l);

          const m = {
            matchId: generate(), // matchId
            group: groupIx + 1,
            attempt: attemptIx + 1,
            team: team,
            beginTime: bTime,
            endTime: bTime + l
          };

          // if (attemptIx + 1 > 3 ) {
          //   m.matchType = 'PLAYOFF';
          // }
          matches.push(m);
        }
        return matches;
      }, matchTeams);
    }),
    flatten
  )(teams);
};



// WEBPACK FOOTER //
// ./src/private/admin/utils/scheduler/points.js